import Vue from 'vue'
import { Loading } from 'element-ui'

export async function loadingData(fn) {
    let loading = Loading.service()
    try {
        await fn()
    }
    finally {
        loading.close()
    }
}

export const EventBus = new Vue()
export const getTimeZoneCity = function(){
var timezone = jstz.determine()
    return timezone.name()
}



// WEBPACK FOOTER //
// ./src/utils/index.js